import Drawer from "../../commons/drawer";
import Badge from "../../commons/badge";
import Button from "../../commons/button";
import { capitalize, formatDateMoment, onOpenFile } from "../../../utils/utils";
import icFileDown02 from "../../../assets/images/ic-file-down-02.svg";

export const SopPreviewDrawer = ({ visibility, onHide, data }) => {
    const badgeType =
        data?.status === 'archive' || data?.status === 'archived'
            ? 'archive'
            : data?.status

    const documentUrl = data?.document_url || data?.file_url
    const employees = data?.employees || data?.employee_assignments

    return (
        <Drawer
            visibility={visibility}
            onHide={onHide}
            title="SOP Detail"
        >
            <div className="flex flex-col px-6 space-y-5">
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">SOP Name</p>
                    <p className="text-neutral-80 font-medium">{data?.name || '-'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">SOP Number</p>
                    <p className="text-neutral-80 font-medium">{data?.number || '-'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">SOP Category</p>
                    <p className="text-neutral-80 font-medium">{data?.category?.name || '-'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">SOP File</p>
                    {documentUrl ? (
                        <Button
                            type="outline"
                            title="View File"
                            icon={icFileDown02}
                            onClick={() => onOpenFile({ urls: [documentUrl] }, 'SOP-File')}
                            className="w-fit"
                        />
                    ) : (
                        <p className="text-neutral-80 font-medium">-</p>
                    )}
                </div>
                {data?.additional_links?.length > 0 && (
                    <div className="flex flex-col gap-2">
                        <p className="text-neutral-50 text-sm">Additional Links</p>
                        {data.additional_links.map((link, index) => (
                            <div key={index} className="flex flex-col gap-0.5 pl-3 border-l-2 border-primary-30">
                                <p className="text-neutral-80 font-medium text-sm">{link?.name || '-'}</p>
                                <a
                                    href={link?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary-50 text-sm underline break-all"
                                >
                                    {link?.url || '-'}
                                </a>
                            </div>
                        ))}
                    </div>
                )}
                {employees?.length > 0 && (
                    <div className="flex flex-col gap-2">
                        <p className="text-neutral-50 text-sm">Employee Name</p>
                        <div className="flex flex-wrap gap-2">
                            {employees.map((emp, index) => (
                                <span
                                    key={index}
                                    className="bg-neutral-10 border border-neutral-30 rounded-md px-2 py-1 text-sm text-neutral-80"
                                >
                                    {emp?.name || emp?.full_name || emp?.employee_name || '-'}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
                {data?.employee_types?.length > 0 && (
                    <div className="flex flex-col gap-2">
                        <p className="text-neutral-50 text-sm">Employee Type</p>
                        <div className="flex flex-wrap gap-2">
                            {data.employee_types.map((type, index) => {
                                const typeLabel =
                                    typeof type === 'string'
                                        ? capitalize(type)?.replace(/-/g, ' ')
                                        : type?.label || type?.name || type?.id || '-'
                                return (
                                    <span
                                        key={index}
                                        className="bg-neutral-10 border border-neutral-30 rounded-md px-2 py-1 text-sm text-neutral-80"
                                    >
                                        {typeLabel}
                                    </span>
                                )
                            })}
                        </div>
                    </div>
                )}
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">Status</p>
                    <div>
                        <Badge type={badgeType} title={data?.status || '-'} />
                    </div>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="text-neutral-50 text-sm">Created Date</p>
                    <p className="text-neutral-80 font-medium">
                        {data?.created_at ? formatDateMoment(data.created_at, 'DD MMM YYYY') : '-'}
                    </p>
                </div>
            </div>
        </Drawer>
    );
};
